module.exports = __webpack_public_path__ + "assets/img/signpost.cdfa0e89.png";